<template>
  <div>

    <div class="has-text-centered mb-6" v-if="init.name">
      <h1 class="title is-3">{{init.name}}</h1>
    </div>

    <div class="tabs is-centered is-boxed">
      <ul>
        <li :class="{'is-active': tabActive === 'info'}" @click="tabActive = 'info'">
          <a>
            <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
            <span>Informazioni</span>
          </a>
        </li>
        <li :class="{'is-active': tabActive === 'history'}" @click="tabActive = 'history'" v-if="client._id">
          <a>
            <span class="icon is-small"><font-awesome-icon icon="clock-rotate-left" /></span>
            <span>Storico</span>
          </a>
        </li>
      </ul>
    </div>

    <transition name="fade" mode="out-in">
      <div v-show="tabActive === 'info'">
          
        <form class="columns is-multiline" @submit.prevent="client._id ? updateClient() : saveClient()">
          <div class="column is-12-mobile is-6-tablet is-3-desktop">
            <InputText name="Nome" v-model="client.name" :required="!client.surname && !client.business_name" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-3-desktop">
            <InputText name="Cognome" v-model="client.surname" :required="!client.business_name && !client.name" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="Ragione sociale" v-model="client.business_name" :required="!client.name && !client.surname" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-2-desktop">
            <div class="field">
              <label class="label" for="isInstaller">È un installatore</label>
              <div class="control">
                <input type="checkbox" id="isInstaller" v-model="client.isInstaller">
              </div>
            </div>
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="Indirizzo residenza" v-model="client.address" />
          </div>
          <div class="column is-6-mobile is-3-tablet is-2-desktop">
            <InputText name="Piano residenza" v-model="client.floor" />
          </div>
          <div class="column is-6-mobile is-3-tablet is-2-desktop">
            <InputText name="Interno residenza" v-model="client.interior" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="CAP residenza" v-model="client.zip" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="Città residenza" v-model="client.city" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-2-desktop">
            <InputText name="Provincia" v-model="client.province" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="Codice fiscale" v-model="client.cf" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="Partita IVA" v-model="client.vat" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="SDI" v-model="client.sdi" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="PEC" v-model="client.pec" type="email" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="Email" v-model="client.email" type="email" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="Email 2" v-model="client.email2" type="email" />
          </div>

          <div class="column is-12 p-0"></div>

          <div v-for="(contact, index) in client.contacts" :key="index" class="column is-12-mobile is-6-tablet is-4-desktop">
            <div class="box">
              <div class="columns is-multiline mb-0" style="margin-left: -0.75rem; margin-right: -0.75rem;">
                <div class="column is-6-tablet">
                  <InputText name="Nome" v-model="contact.name" />
                </div>
                <div class="column is-6-tablet">
                  <InputText name="Telefono" v-model="contact.telephone" type="tel">
                    <a class="button is-warning" :href="contact.telephone ? 'tel:'+contact.telephone : ''"><font-awesome-icon icon="phone" class="m-0" /></a>
                  </InputText>
                </div>
              </div>
              <div class="has-text-right">
                <button class="button is-small is-danger" type="button" @click="client.contacts.splice(index, 1)">
                  <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                </button>
              </div>
            </div>
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="$store.getters.amAdmin">
            <div class="is-flex is-justify-content-center is-align-items-center" style="height: 100%">
              <button class="button is-info" type="button" @click="addContact()"><font-awesome-icon icon="plus" />Aggiungi contatto</button>
            </div>
          </div>

          <div class="column is-12 p-0"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Collaboratore preferito"
              v-model="client.favorite_collaborators"
              :options="$store.getters.operators"
              :disabled="!$store.getters.amAdmin"
              id="_id"
              track-by="_id"
              :custom-label="$fullname"
              :multiple="true"
            />
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <div class="field">
              <label class="label">Abbonamento</label>
              <div class="control is-flex">
                <InputDate v-model="newSub.range" placeholder="Intervallo date" :range="true" :showIcon="true" style="width: 100%;" />
                <button type="button" class="button is-success ml-2" @click="addSub()" :disabled="!newSub.range || !newSub.range.start || !newSub.range.end">
                  <font-awesome-icon icon="plus" />
                  Aggiungi
                </button> 
              </div>
            </div>
          </div>

          <div class="column is-12 p-0"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputTextarea name="Note" v-model="client.notes" />
          </div>

          <div class="column is-full">
            <div class="field is-grouped is-grouped-centered buttons">
              <button @click="goBack()" class="button is-light" type="button"><font-awesome-icon icon="times" />Chiudi</button>
              <button v-if="$store.getters.amAdmin" class="button is-primary" :class="[{'is-loading': disabledSave}]" type='submit' :disabled="disabledSave"><font-awesome-icon icon="save" />Salva</button>
            </div>
          </div>
        </form>

      </div>
    </transition>

    <transition name="fade" mode="out-in" v-if="client._id">
      <div v-show="tabActive === 'history'">
        <Timeline entity="client" :id="client._id" />
      </div>
    </transition>

  </div>
</template>

<script>
import utils from '../utils'

export default {
  data() {
    return {
      client: {
        contacts: []
      },

      tabActive: 'info',

      disabledSave: false,

      init: {
        name: false
      },

      newSub: {
        range: {}
      }
    }
  },

  computed: {
      
  },

  methods: {
    normalizeProvinceCode(value) {
      return (value || '').toString().replace(/[^a-zA-Z]/g, '').toUpperCase().slice(0, 2)
    },

    saveClient() {
      const self = this
      this.disabledSave = true
      this.client.province = this.normalizeProvinceCode(this.client.province)

      this.$http.post('/client', this.client)
      .then(function (response) {
        utils.deleteDraft(self, self.client._timestamp, 'client').then(() => {
          const createdId = response?.data?._id
          if (createdId) {
            self.$router.replace('/clienti/' + createdId)
          } else {
            self.$router.push('/clienti')
          }
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledSave = false
      })
    },

    updateClient() {
      const self = this
      this.disabledSave = true
      this.client.province = this.normalizeProvinceCode(this.client.province)

      this.$http.put('/client/' + this.client._id, this.client)
      .then(function (response) {
        utils.deleteDraft(self, self.client._timestamp, 'client').then(() => {
          self.disabledSave = false
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledSave = false
      })
    },

    addContact() {
      this.client.contacts.push({
        name: '',
        telephone: ''
      })
    },

    goBack() {
      this.$store.commit('setForm', {name: 'client', value: false})
      this.$router.back()
    },

    isExpired(date) {
      return utils.isExpired(date)
    }
  },

  watch: {
    client: {
      handler(value) {
        utils.prepareDraft(this, this.client, value, 'client')
      },
      deep: true
    }
  },

  mounted() {
    const self = this

    const id = this.$route.params.id

    if (id) {
      this.$http.get('/client/' + id)
      .then(function (response) {
        self.client = response.data

        if (self.client.business_name) {
          self.init.name = self.client.business_name
        } else {
          self.init.name = self.$fullname(self.client)
        }
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    } else {
      if (this.$store.getters.getForm('client')) {
        self.client = this.$store.getters.getForm('client')
      }
    }
  }
}
</script>